
import { Timer, Check } from "lucide-react";
import { Button } from "./ui/button";
import { goToHeroOrderForm } from '@/lib/utils';


const LimitedOfferSection = () => {
  
  
  return (
    <section className="light-section">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-xl border border-book-yellow">
          <div className="flex items-center justify-center gap-3 mb-6">
            <Timer className="h-6 w-6 text-book-yellow" />
            <h2 className="text-2xl md:text-3xl font-bold text-book-darkBg">
              This Is A Truly Limited Offer
            </h2>
          </div>
          
          <p className="text-center text-gray-700 mb-8">
            Claim Your Physical Copy Now While Stock Lasts
          </p>
          
          <div className="space-y-4 mb-8">
            <div className="flex items-start">
              <div className="flex-shrink-0 mt-1">
                <Check className="h-5 w-5 text-green-500" />
              </div>
              <p className="ml-3 text-gray-700">
                <span className="font-bold">Free Physical Book</span> - Just cover the small shipping fee
              </p>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 mt-1">
                <Check className="h-5 w-5 text-green-500" />
              </div>
              <p className="ml-3 text-gray-700">
                <span className="font-bold">Three Valuable Bonuses</span> - To accelerate your consulting journey
              </p>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 mt-1">
                <Check className="h-5 w-5 text-green-500" />
              </div>
              <p className="ml-3 text-gray-700">
                <span className="font-bold">Risk-Free Guarantee</span> - If you don't love it, we'll refund your shipping cost
              </p>
            </div>
          </div>
          
          <div className="text-center">
            <Button 
              onClick={goToHeroOrderForm}
              className="bg-book-yellow hover:bg-book-yellow/90 text-book-darkBlue font-bold py-4 px-6 text-base uppercase tracking-wide shadow-lg transition-all duration-300"
            >
              Rush Me A Free Copy
            </Button>
            
            <p className="text-sm text-gray-500 mt-4">
              *We only have a limited number of copies available and this page will be removed once they're gone
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LimitedOfferSection;
